import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { LicenseManager  } from 'ag-grid-enterprise';
import { LicenseManager as CoreLicenseManager  } from '@ag-grid-enterprise/core';

import Notification from 'components/Notification';
import PreLoaderWidget from 'components/Loader';

import Routes from 'routes';
import store from 'store';

const loadLicense = () => {
    console.log(process.env.AG_GRID_ENTERPRISE_KEY)
    LicenseManager.setLicenseKey(process.env.AG_GRID_ENTERPRISE_KEY);
    CoreLicenseManager.setLicenseKey(process.env.AG_GRID_ENTERPRISE_KEY);
};

loadLicense();

const Root = () => (
    <Provider store={store}>
        <BrowserRouter basename="/">
             <Notification/>
            <PreLoaderWidget/>
            <Routes/>
        </BrowserRouter>
    </Provider>
);

export default Root;
